import { useQuery } from './useQuery'
import { UseQueryParamHook } from '../types'

export const useQueryParam: UseQueryParamHook = (key: string) => {
    const [q, setQ] = useQuery()

    return [
        q[key],
        p => {
            setQ({
                [key]: p
            })
        }
    ]
}
